<template>
  <div class="w-full">
    <vs-button
      icon="add"
      type="line"
      size="small"
      :disabled="!$atividades.permissoes.includes(5)"
      @click="openModal()"
      color="success"
    >
      <b style="font-size: 16px">Incluir</b>
    </vs-button>
    <vs-popup
      v-if="open"
      title="Nova Conta a Receber"
      :active.sync="modalCadastrar"
    >
      <div class="w-full vs-con-loading__container" id="loadingCR">
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <div>
              <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                >Cliente</label
              >
              <br />
              <el-select
                filterable
                clearable
                remote
                :remote-method="filtroCliente"
                name="cliente"
                :loading="loading"
                placeholder="Pesquise"
                loading-text="Buscando..."
                style="width: 181px"
                v-model="conta.id_cliente"
                :popper-append-to-body="false"
                class="mx-1 mt-2"
              >
                <el-option
                  v-for="cliente in clientes"
                  :value="cliente.id"
                  :label="cliente.nome_fantasia"
                  :key="cliente.id"
                ></el-option>
              </el-select>
            </div>
            <div>
              <vs-input
                color="dark"
                class="mx-1"
                type="text"
                style="width: 181px"
                label="Número da Nota"
                v-model="conta.nota"
              ></vs-input>
            </div>
            <div>
              <vs-input
                color="dark"
                class="mx-1"
                v-currency="$currencyFormatterOptions"
                style="width: 181px"
                type="text"
                name="valor"
                label="Valor"
                v-model="conta.valor"
              ></vs-input>
            </div>
          </vs-col>
        </vs-row>
        <div id="incluirSelects" class="vs-con-loading__container">
          <vs-row
            vs-type="flex"
            class="mb-2 mt-2"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="12"
            >
              <div>
                <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                  >Empresa</label
                >
                <br />
                <el-select
                  filterable
                  clearable
                  name="empresa"
                  v-model="conta.id_empresa"
                  :popper-append-to-body="false"
                  class="mx-1 mt-2"
                >
                  <el-option
                    v-for="empresa in empresas"
                    :value="empresa.id"
                    :label="empresa.razao_social"
                    :key="empresa.id"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                  >Portador</label
                >
                <br />
                <el-select
                  filterable
                  name="portador"
                  clearable
                  :popper-append-to-body="false"
                  v-model="conta.id_portador"
                  class="mx-1 mt-2"
                >
                  <el-option
                    v-for="portador in portadores"
                    :value="portador.id"
                    :label="portador.nome"
                    :key="portador.id"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                  >Plano Conta</label
                >
                <br />
                <el-select
                  filterable
                  clearable
                  name="plano_conta"
                  remote
                  :remote-method="filtroPlanoConta"
                  :popper-append-to-body="false"
                  :loading="loading"
                  loading-text="Buscando..."
                  placeholder="Pesquise"
                  v-model="conta.id_plano_conta"
                  class="mx-1 mt-2"
                >
                  <el-option
                    v-for="data in plano_conta"
                    :value="data.id"
                    :label="data.nome"
                    :key="data.id"
                  ></el-option>
                </el-select>
              </div>
            </vs-col>
          </vs-row>
          <vs-row
            vs-type="flex"
            class="mb-2"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-col
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="flex-end"
              vs-w="12"
            >
              <div>
                <label style="color: black; font-size: 0.85rem" class="m-0 pl-3"
                  >Forma de Pagamento</label
                >
                <br />
                <el-select
                  filterable
                  clearable
                  name="forma_pagamento"
                  style="width: 179px"
                  :popper-append-to-body="false"
                  v-model="conta.id_forma_pagamento"
                  class="mx-1 mt-2"
                >
                  <el-option
                    v-for="tipo in formasPagamento"
                    :value="tipo.id"
                    :label="tipo.nome"
                    :key="tipo.id"
                  ></el-option>
                </el-select>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-row
          vs-type="flex"
          class="mb-2 mt-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <div class="w-full">
              <vs-input
                color="dark"
                name="emissao"
                class="mx-2"
                type="date"
                @change="checkData"
                style="width: 270px"
                label="Data Emissão"
                v-model="conta.data_emissao"
              ></vs-input>
            </div>
            <div class="w-full">
              <vs-input
                class="mx-2"
                color="dark"
                name="vencimento"
                style="width: 270px"
                type="date"
                label="Data Vencimento"
                v-model="conta.data_vencimento"
              ></vs-input>
            </div>
          </vs-col>
        </vs-row>
        <vs-row
          vs-type="flex"
          class="mb-2"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-input
              color="dark"
              class="mx-1 w-fulll"
              style="width: 600px"
              type="text"
              label="Observação"
              v-model="conta.obs"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-col
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            vs-w="12"
          >
            <vs-button
              @click="submitForm()"
              class="w-full mt-3"
              color="danger"
              type="relief"
              >Incluir</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
export default {
  data() {
    return {
      empresas: {},
      portadores: {},
      plano_conta: {},
      formasPagamento: {},
      modalCadastrar: false,
      conta: { id_status: 1, parcela: 1, tipo: 2 },
      clientes: {},
      loading: false,
      open: false
    };
  },
  methods: {
    async submitForm() {
      try {
        if (
          this.conta.id_cliente != null &&
          this.conta.valor != null &&
          this.conta.id_empresa != null &&
          this.conta.id_portador != null &&
          this.conta.id_plano_conta != null &&
          this.conta.id_forma_pagamento != null &&
          this.conta.data_emissao != null && this.conta.data_emissao != "" && this.conta.data_emissao != null &&
          this.conta.data_vencimento != null && this.conta.data_vencimento != "" && this.conta.data_vencimento != undefined
        ) {
          this.Cadastrar();
        } else {
          this.$vs.notify({
            title: "Preencha os campos obrigatorios",
            text:
              "Cliente <br> Portador <br> Valor <br> Forma de pagamento <br> Data de emissao e venicmento <br> Plano Conta <br> Empresa",
            color: "danger"
          });
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async Cadastrar() {
      await this.$vs.loading({ container: "#loadingCR", scale: 0.6 });
      try {
        let valor = "" + this.conta.valor;
        if (valor && valor.search(",") !== -1) {
          valor = valor.replace(/\./g, "");
          valor = valor.replace(/,/g, ".");
        }
        this.conta.valor = valor;
        const res = this.$http.post("conta", this.conta);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "cadastrar",
          setor: "financeiro",
          ip: window.localStorage.getItem("ip"),
          texto: "Cadastro da Conta a Receber N°" + res.id
        };
        await this.$logger(logData);
        this.$emit("update");
        this.modalCadastrar = false;
        this.conta = {};
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$emit("update");
        this.modalCadastrar = await false;
        this.open = await false;
        this.conta = await {};
      }
      await this.$vs.loading.close("#loadingCR > .con-vs-loading");
    },
    async getEmpresas() {
      try {
        this.empresas = await this.$http.get(`empresa`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getPlanoContaByQuery(query) {
      try {
        this.plano_conta = await this.$http.post(`getPlanoContaByQuery`, {
          query: query
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getFormasPagamento() {
      try {
        this.formasPagamento = await this.$http.get(`formasPagamento`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getPortadores() {
      try {
        this.portadores = await this.$http.get(`portador`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async getClientes(query) {
      try {
        this.clientes = await this.$http.post(`getClienteByQuery`, {
          query: query
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    async openModal() {
      this.open = await true;
      this.modalCadastrar = await true;
      await this.$vs.loading({ container: "#incluirSelects", scale: 0.6 });
      try {
        await this.getPortadores();
        await this.getEmpresas();
        await this.getFormasPagamento();
        this.conta.data_emissao = await this.$formartData.dataFiltro();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        await this.$vs.loading.close("#incluirSelects > .con-vs-loading");
      }
    },
    async filtroCliente(query) {
      if (query.length > 2) {
        try {
          this.loading = await true;
          await this.getClientes(query);
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
        } finally {
          this.loading = await false;
        }
      }
    },
    async filtroPlanoConta(query) {
      if (query.length > 2) {
        this.loading = await true;
        try {
          await this.getPlanoContaByQuery(query);
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
        } finally {
          this.loading = await false;
        }
      }
    },
    async checkData() {
      if (this.$atividades.permissoes.includes(25)) {
        return 1;
      }
      var hoje = new Date();
      var data = new Date(this.conta.data_emissao);

      var dia_hoje = hoje.getUTCDate();
      var mes_hoje = hoje.getUTCMonth() + 1;
      var dia_data = data.getUTCDate();
      var mes_data = data.getUTCMonth() + 1;
      var ano_hoje = hoje.getUTCFullYear();
      var ano_data = data.getUTCFullYear();

      console.log("dia_hoje - " + dia_hoje);
      console.log("mes_hoje - " + mes_hoje);
      console.log("dia_data - " + dia_data);
      console.log("mes_data - " + mes_data);
      console.log("ano_hoje - " + ano_hoje);
      console.log("ano_data - " + ano_data);
      if (ano_data < ano_hoje && 0) {
        this.conta.data_emissao = hoje.toISOString().split("T")[0];
        this.$vs.notify({
          title:
            "Não é possível mudar o vencimento do ano anterior. ERR COD 03",
          text: "Ação Negada",
          color: "danger"
        });
        return 1;
      }
      if (dia_hoje > 5) {
        if (mes_data < mes_hoje) {
          this.conta.data_emissao = hoje.toISOString().split("T")[0];
          this.$vs.notify({
            title:
              "Não é possível mudar o vencimento do mês anterior. ERR COD 01",
            text: "Ação Negada",
            color: "danger"
          });
          return 1;
        }
      } else {
        if (mes_hoje + 1 < mes_data && !(mes_hoje == 1 && mes_data == 12)) {
          this.conta.data_emissao = hoje.toISOString().split("T")[0];
          this.$vs.notify({
            title:
              "Não é possível mudar o vencimento do mês anterior. ERR COD 02",
            text: "Ação Negada",
            color: "danger"
          });
          return 1;
        }
      }
    }
  },
  async mounted() {},
  components: { ...components }
};
</script>
